<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="share-survey-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Sharing</mat-card-title>

      <mat-card-subtitle>
        When your survey’s ready, share it with collectors and other organizers.
      </mat-card-subtitle>

      <button mat-flat-button class="share-survey-button" (click)="openShareDialog()">
        <mat-icon class="material-symbols-outlined">
          group
        </mat-icon>

        <div>Add data collectors</div>
      </button>
    </mat-card-header>

    <mat-card-content>
      <ground-share-list></ground-share-list>
    </mat-card-content>
  </mat-card>
</div>
